import {
	ENDPOINT_URL,
	GET_AP_LIST,
	GET_SSID_DETAILS,
	URL_FILTERING,
} from '../../constants/commonConstants';
import axios from 'axios';
import { decryptData } from '../../utils/crypto';

export const getApsBySite = async (siteId, userInfo) => {
	const url = ENDPOINT_URL + GET_AP_LIST + siteId + '/';
	const config = {
		method: 'get',
		maxBodyLength: Infinity,
		url: url,
	};

	try {
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		return data?.results || [];
	} catch (error) {
		console.error('Error in getApsBySite:', error);
		return []; // Return an empty array in case of error
	}
};

export const deleteSSIDfromT4 = async (userInfo, prevSsidName, apInSite, siteId) => {
	try {
		if (prevSsidName) {
			const obj = {
				ssid: prevSsidName,
				serialNo: apInSite,
				siteId: siteId,
			};

	const t4urlFilteringUrl = URL_FILTERING;
	const t4Apiconfig = {
		method: 'put',
		maxBodyLength: Infinity,
		url: t4urlFilteringUrl,
		data: obj, // Payload should be under `data` in Axios
	};

			const response = await axios.request(t4Apiconfig);
			if (response?.data?.type === 'success') {
				console.log('SSID deleted successfully');
			} else if (response?.data?.type === 'error') {
				console.log('Error in deleting SSID');
			}
		}
	} catch (e) {
		console.log('Error in Url filtering', e);
	}
};

export const moveAPFromT4 = async (userInfo, apListArr, destSiteId) => {
	try {
		if (destSiteId?.site_id && apListArr?.apSerialNums) {
			let serialNos = [];
			serialNos = apListArr?.apSerialNums?.map((obj) => {
				return {
					serialNo : obj.apSerialNum
				}
			})
			const obj = {
				apListArr: serialNos,
				destSiteId: destSiteId.site_id,
			};

			const t4urlFilteringUrl = URL_FILTERING + '/move-ap';
			const t4Apiconfig = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: t4urlFilteringUrl,
			data: obj, // Payload should be under `datain Axios
			};

			const response = await axios.request(t4Apiconfig);
			if (response?.data?.type === 'success') {
				console.log('AP moved to new site.');
			} else if (response?.data?.type === 'error') {
				console.log('Error in deleting SSID');
			}
		}
	} catch (e) {
		console.log('Error in Url filtering', e);
	}
};

export const urlstoT4 = async (
	userInfo,
	ssidFormData,
	ssidApiResp,
	siteId,
	ssidFormType,
	prevSsidName
) => {
	try {
		const apInSite = await getApsBySite(siteId, userInfo);
		console.log('error in urlfiltering api urls', apInSite);
		if (apInSite?.length < 1) return;

		let apiCallType;
		let ssidName;
		let payload;

		if (ssidFormType === 'add') {
			apiCallType = 'POST';
			if (
				ssidApiResp?.radiobutton_urlfilter === '3' &&
				ssidApiResp?.ssid_url_status === 1
			) {
				ssidApiResp.radiobutton_urlfilter = '1';
			}
			let websiteList = ssidApiResp?.ssid_urls
				? ssidApiResp?.ssid_urls.split(',')
				: [];
			websiteList = websiteList?.filter((str) => str !== '');
			ssidName = ssidFormData?.ssid_name;
			payload = {
				siteId: siteId,
				websiteList: websiteList,
				serialNo: apInSite?.map((ap) => ap?.serial_no),
				ssid: ssidName,
				restricted: parseInt(ssidApiResp?.radiobutton_urlfilter),
			};
		} else {
			apiCallType = 'PATCH';
			let editwebsiteList = ssidApiResp?.ssid_urls
				? ssidApiResp?.ssid_urls.split(',')
				: [];
			editwebsiteList = editwebsiteList?.filter((str) => str !== '');
			const ssidName = ssidFormData?.ssid_name;
			// if it is default it should be empty 
			if(parseInt(ssidApiResp?.radiobutton_urlfilter) !== 1 && parseInt(ssidApiResp?.radiobutton_urlfilter) !== 2) {
				editwebsiteList = []
			}
			payload = {
				websiteList: editwebsiteList,
				siteId: siteId,
				serialNo: apInSite?.map((obj) => obj.serial_no) || [],
				ssid: ssidName,
				restricted: parseInt(ssidApiResp?.radiobutton_urlfilter),
			};
		}

		const t4urlFilteringUrl = URL_FILTERING + '/ssid';
		const t4Apiconfig = {
			method: apiCallType,
			maxBodyLength: Infinity,
			url: t4urlFilteringUrl,
			data: payload,
		};

		const response = await axios.request(t4Apiconfig);
		if (response?.data?.type === 'success') {
			// if (apiCallType === 'PATCH' && prevSsidName !== ssidName) {
			// 	deleteSSIDfromT4(userInfo, prevSsidName, payload.serialNo, siteId);
			// }
		} else if (response?.data?.type === 'error') {
			console.log('Error in URL filtering');
		}
	} catch (e) {
		console.log('Error in URL filtering', e);
	}
};

export const retrieveChild = async (
	userInfo,
	ssidApiResp,
	method,
	prevSsidName
) => {
	try {
		console.log('ssid api resp', ssidApiResp);
		// const intervalId = setInterval(async () => {
		const url =
			ENDPOINT_URL +
			GET_SSID_DETAILS +
			'?site_id=' +
			ssidApiResp.site_id +
			'&ssid_id=' +
			ssidApiResp.ap_ssid_id;
		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('ssid detaislssssss', data);
		if (data.results) {
			// Call t4parentchild() once data is available
			t4parentchild(
				userInfo,
				data.results,
				method,
				ssidApiResp.site_id,
				prevSsidName
			);

			// Clear the interval after processing
			// clearInterval(intervalId);
			return; // Stop execution once interval is cleared
		}
		// }, 2000); // Check every 2 seconds

		// return () => clearInterval(intervalId); // Return a function to manually clear the interval if needed
	} catch (e) {
		console.log('Error in retrieve child', e);
	}
};

export const t4parentchild = async (
	userInfo,
	ssiddetails,
	method,
	siteId,
	prevSsidName
) => {
	try {
		const apInSite = await getApsBySite(siteId, userInfo);
		if (ssiddetails) {
			// Loop through ssiddetails array, ensuring we only process actual array elements
			for (const i in ssiddetails) {
				// Filter unwanted prototype properties using hasOwnProperty
				if (ssiddetails?.hasOwnProperty(i)) {
					const ssidDetail = ssiddetails[i];

					if (ssidDetail?.serial_nos?.length >= 1) {
						let websiteList = ssidDetail?.website_list
							? ssidDetail?.website_list.split(',')
							: [];
						websiteList = websiteList?.filter((str) => str !== '');
						if (
							ssidDetail?.restricted === '3' &&
							ssidDetail?.url_filter_status === 1
						) {
							ssidDetail.restricted = '1';
						}
						const payload = {
							websiteList: websiteList,
							siteId: ssidDetail?.site_id,
							serialNo: ssidDetail?.serial_nos,
							ssid: ssidDetail?.ssid_name,
							restricted: parseInt(ssidDetail?.restricted),
						};

						console.log('t4parent child', payload);
						const t4urlFilteringUrl = URL_FILTERING + '/ssid';
						const config = {
							method: method,
							maxBodyLength: Infinity,
							url: t4urlFilteringUrl,
			data: payload,
						};

						const response = await axios.request(config);
						if (response?.body?.type === 'success') {
							// add any message if needed
						} else if (response?.body?.type === 'error') {
							// add any message if needed
						}

						if (
							method === 'PATCH' &&
							prevSsidName !== ssidDetail?.ssid_name
						) {
							const deletePayload = {
								ssid: prevSsidName,
								serialNo: apInSite,
								siteId: ssidDetail?.site_id,
							};
							deletechildssid(userInfo, deletePayload, false);
						}
					}
				}
			}
		}
	} catch (e) {
		console.log('Error', e);
	}
};

const deleteData = async (userInfo, payload) => {
	const url = ENDPOINT_URL + GET_SSID_DETAILS;
	const config = {
		method: 'POST',
		maxBodyLength: Infinity,
		url: url,
		data: payload,
	};
	const response = await axios.request(config);
	return response;
};
export const deletechildssid = async (userInfo, payload, data) => {
	try {
		if (payload) {
			const url = URL_FILTERING;
		const config = {
			method: 'put',
			maxBodyLength: Infinity,
			url: url,
			data: payload,
		};

			const response = await axios.request(config);
			if (response?.data?.type === 'success') {
				// console.log('Child SSID deleted successfully');
			} else if (response?.data?.type === 'error') {
				// console.log('Error in deleting child SSID');
			}
		} else if (data) {
			const deleteResponse = await deleteData(userInfo, data); // Assuming deleteData is a service function
			if (deleteResponse?.data) {
				const childparentssid = deleteResponse?.data;
				const url = URL_FILTERING;

				for (const i in childparentssid) {
					// Ensure we're only iterating over the own properties of the array/object
					if (childparentssid?.hasOwnProperty(i)) {
						const payload = {
							ssid: childparentssid[i]?.ssid_details,
							serialNo: childparentssid[i]?.serial_nos,
							siteId: childparentssid[i]?.site_id,
						};

						const config = {
						method: 'put',
						maxBodyLength: Infinity,
						url: url,
						data: payload, // Note: In Axios, the payload data is sent via the `data` property.
					};

						try {
							await axios.request(config);
						} catch (error) {
							console.error(
								'Error in sending request for childparentssid:',
								error
							);
						}
					}
				}
			}
		}
	} catch (e) {
		console.error('Error in deletechildssid (data):', e);
	}
};

export default getApsBySite